const IconLocation = ({ className }) => {
    return (
        <svg
            className={className}
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.8347 21.9371C14.2146 20.0804 17.0207 16.2606 18.2009 14.3344C19.1451 12.795 20 11.1289 20 9.17121C20 4.65784 16.4178 1 11.9993 1C7.58223 1 4 4.65784 4 9.17121C4 11.1466 4.84021 12.8399 5.82712 14.3698C7.02754 16.2339 9.8594 20.0724 11.2467 21.9369C11.644 22.4709 12.4377 22.4713 12.8347 21.9371ZM12 12C13.6567 12 15 10.6557 15 9.00065C15 7.34431 13.6567 6 12 6C10.3433 6 9 7.34431 9 9.00065C9 10.6557 10.3433 12 12 12Z'
            />
        </svg>
    );
};

export default IconLocation;
